import { render, staticRenderFns } from "./ModalSuporteAnestesistas.vue?vue&type=template&id=096f7b62&scoped=true"
import script from "./ModalSuporteAnestesistas.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteAnestesistas.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteAnestesistas.vue?vue&type=style&index=0&id=096f7b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f7b62",
  null
  
)

export default component.exports